import { useCallback, useEffect } from 'react';

// local imports
import { PharmacyService } from 'app/services';
import useDataApi from '../../../use-data-api';

// initial location coordinates => Ankara - Kızılay
const center = {
  lat: 39.9207429999,
  lon: 32.8539889999
};

const usePharmacyDetailService = pharmacyId => {
  const [service, setService] = useDataApi();

  const fetchData = useCallback(async () => {
    // pharmacy details
    const pharmacyDetail = PharmacyService.getPharmacyDetail(pharmacyId);
    const pharmacyLocation = PharmacyService.getPharmacyLocation(pharmacyId);

    const [pharmacyDetails, pharmacyLocations] = await Promise.all([
      pharmacyDetail,
      pharmacyLocation
    ]);

    // Pharmacy information destructuring...
    const pharmacyDetailData = pharmacyDetails?.data?.data;
    const pharmacyLocationData = pharmacyLocations?.data?.data;

    const { city, district, region, ...rest } = pharmacyDetailData;
    const { lat, lon } = pharmacyLocationData;

    const coordinates = {
      lat: lat ?? center.lat,
      lng: lon ?? center.lon
    };

    return {
      city_id: { label: city.name, value: city.id },
      district_id: { label: district.name, value: district.id },
      region_id: { label: region.name, value: region.id },
      coordinates,
      ...rest
    };
  }, [pharmacyId]);

  useEffect(() => setService(() => fetchData()), [fetchData, setService]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default usePharmacyDetailService;
